<template>
  <div id="app">
    <div class="app-loaded">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
//amplify
import { components } from 'aws-amplify-vue';
import store from './store/store';
import { I18n } from 'aws-amplify';
import { Translations } from '@aws-amplify/ui-components';

export default {
  name: 'app',
  data() {
    return {};
  },
  store,
  components: {
    ...components,
  },
  async mounted() {
    // Set I18n Translations
    //de-DE
    I18n.putVocabulariesForLanguage('de', {
      [Translations.SIGN_IN_HEADER_TEXT]: 'Zugangsdaten eingeben',
      [Translations.SIGN_IN_ACTION]: 'Anmelden',
      [Translations.FORGOT_PASSWORD_TEXT]: 'Passwort vergessen?',
      [Translations.RESET_PASSWORD_TEXT]: 'Passwort zurücksetzen',
      [Translations.RESET_YOUR_PASSWORD]: 'Passwort zurücksetzen',
      [Translations.NEW_PASSWORD_LABEL]: 'Neues Passwort *',
      [Translations.PASSWORD_LABEL]: 'Passwort *',
      [Translations.PASSWORD_PLACEHOLDER]: 'Passwort eingeben',
      [Translations.USERNAME_LABEL]: 'E-Mail-Adresse *',
      [Translations.USERNAME_PLACEHOLDER]: 'E-Mail-Adresse eingeben',
      [Translations.SIGN_UP_PASSWORD_PLACEHOLDER]: 'Passwort',
      [Translations.SIGN_UP_USERNAME_PLACEHOLDER]: 'E-Mail-Adresse',
      [Translations.SIGN_OUT]: 'Abmelden',
      [Translations.FAMILY_NAME_LABEL]: 'Nachname',
      [Translations.NAME_LABEL]: 'Vorname',
    });
    const dict = {
      de: {
        Password: 'Passwort',
        'Forget your password? ': 'Passwort vergessen?',
        'Enter your Username': 'E-Mail-Adresse eingeben',
        'New Password': 'Neues Passwort',
        'Resend Code': 'Code erneut senden',
        'Back to Sign In': 'Zurück',
        'Send Code': 'Code senden',
        'Username cannot be empty': 'Bitte geben Sie einen Benutzernamen ein',
        'Incorrect username or password.': 'Benutzername oder Passwort falsch.',
        "2 validation errors detected: Value at 'userAlias' failed to satisfy constraint: Member must satisfy regular expression pattern: [\\p{L}\\p{M}\\p{S}\\p{N}\\p{P}]+; Value at 'userName' failed to satisfy constraint: Member must satisfy regular expression pattern: [\\p{L}\\p{M}\\p{S}\\p{N}\\p{P}]+":
          'Fehler im Benutzername. Bitte stellen Sie sicher, dass sich keine Leerzeichen am Anfang oder Ende befinden.',
        'CUSTOM_AUTH is not enabled for the client.':
          'CUSTOM_AUTH ist für den Client nicht aktiviert.',
        "PreAuthentication failed with error Das Attribute 'custom:updatedAt' fehlt. Bitte kontaktieren Sie ihren Administrator..":
          'Die Vorauthentifizierung ist mit einem Fehler fehlgeschlagen. Das Attribut „custom:updatedAt“ fehlt. Bitte kontaktieren Sie Ihren Administrator..',
      },
    };
    I18n.putVocabulariesForLanguage('de', Translations);
    I18n.putVocabularies(dict);
    I18n.setLanguage('de');
  },
};
</script>

<style>
:root {
  --primary-color: 0, 0, 0;
}
html {
  height: 100%;
}

body {
  display: block;
  margin: 0;
  font-family: 'Open Sans', open-sans, sans-serif;
  height: 100%;
}

body.modal-open {
  overflow: hidden;
}

#app {
  height: 100%;
}

.app-loaded {
  height: 100%;
}

html:root {
  --amazonOrange: #ff3366;
  --button-background-color: #ff3366;
  --green: #09baa6;
  --green-darker: #00a08e;
  --link-color: none;
}

/* custom scrollbar*/
/* width */
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #ffff;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgb(117 117 117);
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

::-webkit-scrollbar-track {
  -webkit-box-shadow: none !important;
  background-color: transparent;
}

::-webkit-scrollbar {
  width: 7px !important;
  background-color: transparent;
}
::-webkit-scrollbar-thumb {
  background-color: transparent;
}
.modal .btn-close {
  background-image: url(/img/modal-sprite.67649c98.png);
  background-size: 1293px 1277px;
  background-position: -1278px -577px;
  cursor: pointer;
  border-radius: unset;
  box-shadow: none;
  width: 15px;
  height: 15px;
  padding: 0;
}
.btn-close {
  cursor: pointer;
}

/*Utility Classes */

.pl-30,
.px-30 {
  padding-left: 30px !important;
}
.pr-30,
.px-30 {
  padding-right: 30px !important;
}
.pt-30,
.py-30 {
  padding-top: 30px !important;
}
.pb-30,
.py-30 {
  padding-bottom: 30px !important;
}

.pl-45,
.px-45 {
  padding-left: 45px !important;
}
.pr-45,
.px-45 {
  padding-right: 45px !important;
}
.pt-45,
.py-45 {
  padding-top: 45px !important;
}
.pb-45,
.py-45 {
  padding-bottom: 45px !important;
}

/* tooltip text center */
.b-tooltip .tooltip-inner {
  padding-top: 6px;
}
</style>
